import React, { useState } from 'react';
import { EOrganization, ESnapshotExists } from 'lib/types';
import { ColumnButton } from 'lib/components/ColumnButton';
import { getFirebaseContext } from 'utils/firebase';
import { PublisherPaginationSettingsService } from 'lib/services/publisherPaginationSettingsService';

function NoSettingsFound({
  organization,
  onCreate
}: {
  organization: ESnapshotExists<EOrganization>;
  onCreate: () => void;
}) {
  const [creating, setCreating] = useState(false);
  const createDefaultSettings = async () => {
    setCreating(true);
    try {
      await new PublisherPaginationSettingsService(
        getFirebaseContext()
      ).getOrCreateDefault(organization);
      onCreate();
    } catch (error) {
      window.alert(`Error creating default settings: ${error}`);
    } finally {
      setCreating(false);
    }
  };
  return (
    <ColumnButton
      onClick={createDefaultSettings}
      buttonText="Create default settings"
      type="button"
      primary
      loading={creating}
    />
  );
}

export default NoSettingsFound;
